import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/Topbar";
import Breadcrumb from "../components/Breadcrumb";
import "../styles/Tratamientos.css";

export default function Tratamientos() {

  const [filtros, setFiltros] = useState({
    denominacion: "",
    importe: ""
  });

  const [resultados, setResultados] = useState([]);
  const [nuevo, setNuevo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const buscar = async () => {
    setLoading(true);
    try {
      const params = Object.fromEntries(
        Object.entries(filtros).filter(([_, v]) => v)
      );

      const { data } = await axios.get("/api/tratamientos", {
        params,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      setResultados(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscar();
  }, []);

  const guardarNuevo = async () => {
    await axios.post("/api/tratamientos", nuevo, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    });
    setNuevo(null);
    buscar();
  };

  return (
    <>
      <Topbar />
      <div className="tratamientos-page">
        <Breadcrumb />
        <h2>Tratamientos</h2>

        {/* FILTROS */}
        <div className="filtros">
          <input
            name="denominacion"
            placeholder="Denominación"
            value={filtros.denominacion}
            onChange={handleChange}
          />
          <input
            name="importe"
            placeholder="Importe"
            value={filtros.importe}
            onChange={handleChange}
          />
          <button onClick={buscar}>🔍 Buscar</button>
        </div>

        {/* ACCIONES */}
        <div className="acciones">
          <button onClick={() => setNuevo({
            denominacion: "",
            importe: "",
            grupoTratamiento: "",
            gTratamiento: "",
            precioRef: "",
            nPresupuesto: ""
          })}>
            Nuevo tratamiento
          </button>
        </div>

        {/* TABLA */}
        {loading ? <p>Cargando…</p> : (
          <table className="tabla-resultados">
            <thead>
              <tr>
                <th>ID</th>
                <th>Denominación</th>
                <th>Importe</th>
              </tr>
            </thead>
            <tbody>
              {resultados.map(t => (
                <tr key={t.n_tratamiento}>
                  <td>{t.n_tratamiento}</td>
                  <td>{t.denominacion}</td>
                  <td>{Number(t.importe).toFixed(2)} €</td>
                </tr>
              ))}

              {nuevo && (
                <tr className="fila-nueva">
                  <td>Nuevo</td>
                  <td><input onChange={e => setNuevo({ ...nuevo, denominacion: e.target.value })} /></td>
                  <td><input onChange={e => setNuevo({ ...nuevo, importe: e.target.value })} /></td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        {nuevo && (
          <div className="acciones-inferiores">
            <button className="guardar" onClick={guardarNuevo}>Guardar</button>
            <button className="cancelar" onClick={() => setNuevo(null)}>Cancelar</button>
          </div>
        )}
      </div>
    </>
  );
}
